import { SystemConfigForm } from './SystemConfigForm'
import { SYS_STR as S } from './systemConfigApi'

/**
 * A24.11–A24.15 — platform LIMIT forms. Each field is a real app_settings key
 * read/written via `/admin/settings/system` (fail-soft until the backend struct
 * lists the key). Numeric limits saved as JSON numbers.
 */

/** A24.11 — Ro'yxatdan o'tish sozlamalari. */
export function RegistrationSettings() {
  return (
    <SystemConfigForm
      screenId="A24.11"
      title={S.regTitle}
      description={S.regDesc}
      sections={[
        {
          fields: [
            { key: 'reg_open', label: S.fRegOpen, type: 'bool', def: 'true', hint: S.fRegOpen },
            { key: 'reg_invite_only', label: S.fRegInvite, type: 'bool', def: 'false' },
            { key: 'reg_verify_phone', label: S.fRegVerifyPhone, type: 'bool', def: 'true' },
            { key: 'reg_min_age', label: S.fRegMinAge, type: 'number', def: '16', min: 0, max: 120, mono: true },
            { key: 'reg_max_per_ip', label: S.fRegMaxPerIp, type: 'number', def: '5', min: 1, mono: true },
            { key: 'reg_allowed_countries', label: S.fRegAllowedCountries, mono: true, placeholder: 'UZ, KZ, RU' },
            { key: 'reg_blocked_countries', label: S.fRegBlockedCountries, mono: true, placeholder: '' },
          ],
        },
      ]}
    />
  )
}

/** A24.12 — Media limitlari. */
export function MediaLimits() {
  return (
    <SystemConfigForm
      screenId="A24.12"
      title={S.mediaTitle}
      description={S.mediaDesc}
      sections={[
        {
          fields: [
            { key: 'media_max_photo_mb', label: S.fMaxPhotoMb, type: 'number', def: '10', min: 1, mono: true },
            { key: 'media_max_video_mb', label: S.fMaxVideoMb, type: 'number', def: '2048', min: 1, mono: true },
            { key: 'media_max_file_mb', label: S.fMaxFileMb, type: 'number', def: '2048', min: 1, mono: true },
            { key: 'media_max_voice_sec', label: S.fMaxVoiceSec, type: 'number', def: '600', min: 1, mono: true },
            { key: 'media_max_gif_mb', label: S.fMaxGifMb, type: 'number', def: '20', min: 1, mono: true },
            { key: 'media_max_album_items', label: S.fMaxAlbumItems, type: 'number', def: '10', min: 1, max: 100, mono: true },
          ],
        },
      ]}
    />
  )
}

/** A24.13 — Xabar limitlari. */
export function MessageLimits() {
  return (
    <SystemConfigForm
      screenId="A24.13"
      title={S.msgTitle}
      description={S.msgDesc}
      sections={[
        {
          fields: [
            { key: 'msg_max_length', label: S.fMsgMaxLen, type: 'number', def: '4096', min: 1, mono: true },
            { key: 'msg_caption_max', label: S.fMsgCaptionMax, type: 'number', def: '1024', min: 1, mono: true },
            { key: 'msg_rate_per_min', label: S.fMsgRatePerMin, type: 'number', def: '30', min: 1, mono: true },
            { key: 'msg_edit_window_min', label: S.fMsgEditWindow, type: 'number', def: '2880', min: 0, mono: true },
            { key: 'msg_forward_max', label: S.fMsgForwardMax, type: 'number', def: '100', min: 1, mono: true },
          ],
        },
      ]}
    />
  )
}

/** A24.14 — Guruh/kanal limitlari. */
export function GroupLimits() {
  return (
    <SystemConfigForm
      screenId="A24.14"
      title={S.groupTitle}
      description={S.groupDesc}
      sections={[
        {
          fields: [
            { key: 'group_max_members', label: S.fGroupMaxMembers, type: 'number', def: '200000', min: 1, mono: true },
            { key: 'channel_max_subs', label: S.fChannelMaxSubs, type: 'number', def: '1000000', min: 1, mono: true },
            { key: 'group_max_admins', label: S.fGroupMaxAdmins, type: 'number', def: '50', min: 1, mono: true },
            { key: 'group_max_pinned', label: S.fGroupMaxPinned, type: 'number', def: '5', min: 1, mono: true },
            { key: 'groups_per_user', label: S.fGroupsPerUser, type: 'number', def: '500', min: 1, mono: true },
          ],
        },
      ]}
    />
  )
}

/** A24.15 — Bot limitlari. */
export function BotLimits() {
  return (
    <SystemConfigForm
      screenId="A24.15"
      title={S.botTitle}
      description={S.botDesc}
      sections={[
        {
          fields: [
            { key: 'bot_max_per_user', label: S.fBotMaxPerUser, type: 'number', def: '20', min: 1, mono: true },
            { key: 'bot_msg_rate', label: S.fBotMsgRate, type: 'number', def: '30', min: 1, mono: true },
            { key: 'bot_webhook_max', label: S.fBotWebhookMax, type: 'number', def: '100', min: 1, mono: true },
            { key: 'bot_inline_rate', label: S.fBotInlineRate, type: 'number', def: '50', min: 1, mono: true },
            { key: 'bot_file_max_mb', label: S.fBotFileMaxMb, type: 'number', def: '50', min: 1, mono: true },
          ],
        },
      ]}
    />
  )
}
